import { Tag, Tooltip } from "antd"
import { useTranslation } from 'react-i18next';
import { getStatusDisplayLabel } from "../../utils/workflowHelper";

const ellipsisTextStyle = {
    display: "inline-block",
    maxWidth: 115,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
}

const statusColorMapping = {
    "active": "blue",
    "approved": "green",
    "pending": "orange",
    "refused": "red",
    "submitted": "blue",
    "deleted": "red",
    "draft": "purple",
    "New": "purple"
}

const RequestRow = (props) => {
    const { t, i18n } = useTranslation();
    const { caseId, dueDate, createdOn, status, navigateToRequest, originalWorkflow, workflow } = props
    // The request payload carries no workflow snapshot, so the list hands one in.
    const statusLabel = getStatusDisplayLabel(status, originalWorkflow || workflow, { language: i18n.language, t })

    const getDueDateColor = () => {
        if (!createdOn || createdOn === "--") return "text-gray-600";
        
        const today = new Date();
        const due = new Date(dueDate);
        const timeDiff = due.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
        
        if (daysDiff < 0) return "text-red-600"; // Overdue
        if (daysDiff <= 3) return "text-yellow-600"; // Due soon
        return "text-gray-600"; // Normal
    };    return (
        <div 
            className="w-full px-4 py-0 sm:px-6 py-2.5 hover:bg-gray-50 cursor-pointer transition-colors duration-200 border-b border-gray-100 last:border-b-0"
            onClick={() => navigateToRequest(props)}
        >
            {/* Mobile Layout */}
            <div className="block md:hidden space-y-1.5">
                <div className="flex justify-between items-center">
                    <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-medium text-gray-900 truncate">
                            {caseId}
                        </h3>
                    </div>                    <Tooltip title={statusLabel}>
                        <Tag
                            color={statusColorMapping[status] || "orange"}
                            className="ml-2 text-xs font-medium capitalize"
                            bordered={false}
                            style={{ margin: 0, padding: '2px 8px', fontSize: '13px', lineHeight: '16px', maxWidth: '100%' }}
                        >
                            <span style={ellipsisTextStyle}>{statusLabel}</span>
                        </Tag>
                    </Tooltip>
                </div>
                <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{t('Due:')}</span>
                    <span className={`text-xs font-medium ${getDueDateColor()}`}>
                        {dueDate || "--"}
                    </span>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:grid md:grid-cols-12 md:gap-4 md:items-center md:min-h-[40px]">
                <div className="col-span-3">
                    <div className="text-sm font-medium text-gray-900 truncate">
                        {caseId}
                    </div>
                </div>
                <div className="col-span-3">
                    <Tooltip title={statusLabel}>
                        <Tag
                            color={statusColorMapping[status] || "orange"}
                            className="text-xs font-medium capitalize"
                            bordered={false}
                            style={{ margin: 0, padding: '2px 8px', fontSize: '12px', lineHeight: '18px', maxWidth: '100%' }}
                        >
                            <span style={ellipsisTextStyle}>{statusLabel}</span>
                        </Tag>
                    </Tooltip>
                </div>
                <div className="col-span-3">
                    <span className={`text-sm font-medium ${getDueDateColor()}`}>
                        {dueDate || "--"}
                    </span>
                </div>
                <div className="col-span-3">
                    <span className="text-sm font-medium text-gray-600">
                        {createdOn || "--"}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default RequestRow
